import React from 'react';
import '../../styles/style.css';
import gallery1 from "../../assets/images/gallery1.png";
import gallery2 from "../../assets/images/gallery2.png";
import gallery3 from "../../assets/images/gallery3.png";
import gallery4 from "../../assets/images/gallery4.png";
import gallery5 from "../../assets/images/gallery5.png";
import gallery6 from "../../assets/images/gallery6.png";
import gallery7 from "../../assets/images/gallery7.png";
import gallery8 from "../../assets/images/gallery8.png";

const Gallery = () => (
  <div className="gallery_home">
    <div className="gallery_home_desktop">
      <div className="album">
        <div className="responsive-container-block bg">
          {[gallery1, [gallery2, gallery3], [gallery4, gallery5], [gallery6, gallery7], gallery8].map((img, index) => (
            <div key={index} className="responsive-container-block img-cont">
              {Array.isArray(img) ? img.map((src, idx) => <img key={idx} src={src} alt={`Gallery ${index + idx + 1}`} />) : <img src={img} alt={`Gallery ${index + 1}`} />}
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="gallery_home_mobile">
      <div className="container">
        <div className="row">
          {[[gallery4, gallery5], [gallery6, gallery7]].map((imgs, index) => (
            <div key={index} className="col-md-6 col-lg-6 col-sm-6 col-6">
              {imgs.map((src, idx) => <img key={idx} src={src} alt={`Gallery ${index + idx + 4}`} />)}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default Gallery;